import { Button, Drawer, TextField } from '@medly-components/core';
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
`;

export const Header = styled(Drawer.Header)`
    padding: 4.2rem 2.8rem 0 2.8rem;
`;

export const DrawerWrapper = styled(Drawer)`
    #medly-drawer {
        height: auto;
        gap: 1rem;
        border-radius: 0.8rem;
        animation: none;
        @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
            position: fixed;
            left: 0;
            right: 0;
            top: 50%;
            margin: 0 auto;
            transform: translateY(-50%);
        }

        @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
            top: auto;
            bottom: 0;
        }
    }
    #medly-drawer-close-icon {
        height: 1.6rem;
        width: 1.6rem;
    }
`;

export const Content = styled(Drawer.Content)`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    row-gap: 3.2rem;
    padding: 0 2.8rem 2.8rem 2.8rem;

    ${TextField.Style} {
        width: 100%;
    }
`;

export const Footer = styled(Drawer.Footer)`
    padding: 2.4rem;

    ${Button.Style} {
        margin-left: 0;
    }
`;
